// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AssignmentSearchController from "./assignment_search_controller"
application.register("assignment-search", AssignmentSearchController)

import BarcodeLookupController from "./barcode_lookup_controller"
application.register("barcode-lookup", BarcodeLookupController)

import BarcodeScannerController from "./barcode_scanner_controller"
application.register("barcode-scanner", BarcodeScannerController)

import ModalOpenerController from "./modal_opener_controller"
application.register("modal-opener", ModalOpenerController)

import NotificationOffcanvasController from "./notification_offcanvas_controller"
application.register("notification-offcanvas", NotificationOffcanvasController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import PasswordConfirmationController from "./password_confirmation_controller"
application.register("password-confirmation", PasswordConfirmationController)

import PhoneNumberController from "./phone_number_controller"
application.register("phone-number", PhoneNumberController)

import ReturnAnotherController from "./return_another_controller"
application.register("return-another", ReturnAnotherController)

import ReturnFormController from "./return_form_controller"
application.register("return-form", ReturnFormController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import LabelModalController from "./label_modal_controller"
application.register("label-modal", LabelModalController)

import ClientRegistrationController from "./client_registration_controller"
application.register("client-registration", ClientRegistrationController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import MapController from "./map_controller"
application.register("map", MapController)
